import axios from '../axios';

export const quickSearch = (lang = 'pl', search = '') => {
  return axios.post(`/products/quick-search`, {
    lang,
    search,
  });
};
